













































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import Banner from '../BaseBanner.vue'
import Button from '../BaseButton.vue'
import Dropdown from '../BaseDropdown.vue'
import Item from '../ItemListItem.vue'
import GiftCard from '../GiftCardListItem.vue'
import CartItemSkeleton from './CartItemSkeleton.vue'
import ConfirmRecurringVIP from './ConfirmRecurringVIP.vue'
import Spinner from '../BaseSpinner.vue'
import VipToggle from './BaseVipToggle.vue'
import Pricing from '@/utils/Pricing'

const cart = namespace('cart')
const user = namespace('user')

@Component({
  components: { Banner, Item, GiftCard, CartItemSkeleton, Button, Dropdown, Spinner, ConfirmRecurringVIP, VipToggle },
})
export default class CartSummary extends Vue {
  @Prop() stock!: Product[]

  @cart.State((state: any) => {
    return state.items.reduce((carry: Item[], item: Item) => {
      const existingSkuIndex = carry.findIndex(aggItem => aggItem.sku === item.sku)
      const product = state.stock.find((product: Product) => product.sku === item.sku)
      if (existingSkuIndex === -1) {
        carry.push({ ...product, quantity: 1, cost: item.cost })
      } else {
        carry[existingSkuIndex].quantity += item.quantity
        carry[existingSkuIndex].cost += item.cost
      }
      return carry
    }, [])
  }) items: Item[]
  @cart.State cards: GiftCard[]
  @cart.State((state: any) => state.shipping.postage / 100) postage: number
  @cart.State((state: any) => {
    return state.shipping.rates.reduce((carry: any, rate: ShippingRate) => {
      carry[`${rate.service} - (${rate.est_delivery_days} days): ${rate.postage === 0 ? 'Free' : `$${rate.postage / 100}`}`] = rate.service
      return carry
    }, {})
  }) rates: {[s: string]: string}
  @cart.State((state: any) => state.shipping.service) service: string
  @cart.State((state: any) => state.totalTax / 100) tax: number
  @cart.State basePrice: number
  @cart.State createNewVIP: boolean
  @cart.State credit: number
  @cart.State discount: number
  @cart.State fetching: boolean
  @user.State isActiveVip: boolean
  @cart.State isVip: boolean
  @cart.State isReturningCustomer: boolean
  @cart.State pricing: Pricing
  @cart.State pricingTier: number
  @cart.State refId: string
  @cart.State subtotal: number

  @cart.Getter discountPercent: number
  @cart.Getter grandTotal: number
  @cart.Getter referralCredit: number
  @cart.Getter referDiscountEligible: boolean
  @cart.Getter availableGiftCardCredit: number
  @cart.Getter welcomeCredit: number

  @cart.Mutation addItem: any
  @cart.Mutation removeItem: any
  @cart.Mutation removeGiftCard: any
  @cart.Mutation setSelectedShippingService: any
  @cart.Mutation setCreateNewVip: (createNewVip: boolean) => void
  @cart.Action updateCart: () => Promise<void>
  @cart.Action fetchCart: () => Promise<void>
  @cart.Action fetchStock: () => Promise<void>
  @user.Action fetchUser: () => Promise<void>

  freeShippingThreshold: number = 2900
  welcomeBackVipDismissed: boolean = false

  update: Function

  debounce (func: Function, wait = 400): any {
    let timeout: number
    return (...args: any[]) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(this, args), wait)
    }
  }

  created () {
    this.update = this.debounce(this.updateCart)
  }

  async mounted () {
    console.log('CartSummary mounted')
    await this.fetchStock()
    await this.fetchCart()
    await this.fetchUser()

    if (window.innerWidth <= 850) {
      const list = this.$refs['cart-items'] as HTMLElement
      list.lastElementChild?.scrollIntoView({ behavior: 'smooth' })
    }
  }

  // when isVip or pricingTier is updated, modify the pricing object to get the new next discount?

  handleShippingServiceChange ($value: string) {
    this.setSelectedShippingService($value)
    this.update()
  }

  setRecurring (isVip: boolean) {
    this.setCreateNewVip(isVip)
    this.update()
  }

  get nextDiscount () {
    this.pricing.isVip = this.isVip
    this.pricing.pricingTier = this.pricingTier
    return Math.floor(this.pricing.nextDiscount * 100)
  }

  incrementItem ({ amount, sku }: { amount: number, sku: string }) {
    if (this.fetching) return

    const item = this.items.find((item: Item) => item.sku === sku)

    if (!item) return // this should probably never happen

    if (amount < item.quantity) {
      this.removeItem(sku)
    } else {
      this.addItem(sku)
    }

    this.update()
  }

  removeCard (code: string) {
    if (this.fetching) return

    this.removeGiftCard(code)

    this.update()
  }
}
